import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { Check, Plus, X } from "lucide-react";

const FormStep = ({
  stepConfig,
  profile,
  onFieldChange,
  onAddCountryEntry,
  onUpdateCountryEntry,
  onRemoveCountryEntry,
}) => (
  <div className="space-y-4">
    {stepConfig.fields.map((field) => (
      <div key={field.key} className="space-y-1.5">
        <Label className="text-sm font-medium">{field.label}</Label>
        {field.type === "select" ? (
          <Select
            value={profile[field.key] || ""}
            onValueChange={(val) => onFieldChange(field.key, val)}
          >
            <SelectTrigger data-testid={`field-${field.key}`}>
              <SelectValue placeholder="Select..." />
            </SelectTrigger>
            <SelectContent>
              {field.options.map((opt) => (
                <SelectItem key={opt.value} value={opt.value}>
                  {opt.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        ) : field.type === "checkbox" ? (
          <div
            className={`flex items-center gap-3 p-3 rounded-xl border-2 cursor-pointer transition-all ${
              profile[field.key] ? "border-primary bg-primary/5" : "border-border"
            }`}
            onClick={() => onFieldChange(field.key, !profile[field.key])}
            data-testid={`field-${field.key}`}
          >
            <div
              className={`w-5 h-5 rounded border-2 flex items-center justify-center ${
                profile[field.key] ? "bg-primary border-primary" : "border-muted-foreground"
              }`}
            >
              {profile[field.key] && <Check className="h-3 w-3 text-white" />}
            </div>
            <span className="text-sm">Yes, I will purchase compliant health insurance</span>
          </div>
        ) : field.type === "country_list" ? (
          <div className="space-y-3">
            {(profile.countries_last_5_years || []).map((entry, idx) => (
              <div key={`country-${idx}`} className="flex gap-2 items-start">
                <Input
                  placeholder="Country"
                  value={entry.country}
                  onChange={(e) => onUpdateCountryEntry(idx, "country", e.target.value)}
                  className="flex-1"
                />
                <Input
                  type="date"
                  value={entry.from_date}
                  onChange={(e) => onUpdateCountryEntry(idx, "from_date", e.target.value)}
                  className="w-36"
                />
                <Input
                  type="date"
                  value={entry.to_date}
                  onChange={(e) => onUpdateCountryEntry(idx, "to_date", e.target.value)}
                  className="w-36"
                />
                <Button variant="ghost" size="icon" onClick={() => onRemoveCountryEntry(idx)}>
                  <X className="h-4 w-4" />
                </Button>
              </div>
            ))}
            <Button
              variant="outline"
              size="sm"
              onClick={onAddCountryEntry}
              data-testid="add-country-entry"
            >
              <Plus className="h-4 w-4 mr-1" /> Add Country
            </Button>
          </div>
        ) : (
          <Input
            type={field.type}
            placeholder={field.placeholder || ""}
            value={profile[field.key] || ""}
            onChange={(e) => onFieldChange(field.key, e.target.value)}
            data-testid={`field-${field.key}`}
          />
        )}
      </div>
    ))}
  </div>
);

export default FormStep;